import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton } from '@mui/material';
import { useUserDataQuery } from '@shared/queries';
import { useAppSelector } from '../../libs/redux/store';
import { CurrentRoute } from '@shared/AppRoutes';

const SectionHeader = (props: {
  onGoBack: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  route: CurrentRoute;
}) => {
  const { onGoBack, route } = props;
  const { data: userData } = useUserDataQuery();
  const isSearchActive = useAppSelector(state => state.appUi.isSearchActive);

  if (isSearchActive) {
    return null;
  }

  if (!route) {
    onGoBack();
    return null;
  }

  return (
    <Box bgcolor={userData?.colorScheme ?? '#c81f5b'}>
      <Stack
        direction="row"
        bgcolor="#f6f6f6"
        borderRadius="15px 15px 0 0"
        alignItems="center"
        paddingTop={1}
        justifyContent="space-between"
      >
        <IconButton onClick={e => onGoBack(e)} sx={{ flexShrink: 0 }}>
          <ArrowBackIcon fontSize="medium" />
        </IconButton>

        <Stack direction="column" justifyContent="center" alignItems="center" sx={{ flexGrow: 1 }}>
          <Typography
            sx={{
              fontSize: '15px',
              fontWeight: 600,
            }}
          >
            {route.breadcrumb}
          </Typography>
        </Stack>
        <Box sx={{ width: 40 }} />
      </Stack>
    </Box>
  );
};

export default SectionHeader;
